import { BalanceSheetOverviewData } from "@/types/balance-sheet-overview.api";
import { getBalanceSheetOverview } from "@/services/balance-sheet-overview";
import { callApiWithChecks } from "./use-template";
import { FULL_YEAR_MONTHS } from "@/lib/time_utils";

export function useBalanceSheetOverview(
    clientId: string,
    connectionId: string,
    months: number[],
    year: number,
    enabled: boolean
) {
    const monthsKey = months.length ? months.join(',') : FULL_YEAR_MONTHS.join(',');
    return callApiWithChecks<BalanceSheetOverviewData>(
        () => getBalanceSheetOverview(clientId, [connectionId], months, year),
        [clientId, connectionId, monthsKey, year],
        enabled,
        { title: 'Error', description: 'Failed to load balance sheet overview' }
    );
}